// frontend/src/screens/HomeScreen.jsx
import Dashboard from '../components/Dashboard';

const HomeScreen = () => {
  return <Dashboard />;
};

export default HomeScreen;
